// MUI Imports
import type { Theme } from '@mui/material';

const tooltip: Theme['components'] = {
  MuiTooltip: {
    defaultProps: {
      placement: 'top',
      disableInteractive: true,
      slotProps: {
        popper: {
          modifiers: [
            {
              name: 'flip',
              options: {
                fallbackPlacements: [
                  'bottom',
                  'right-start',
                  'left-start',
                  'right-end',
                  'left-end',
                ],
              },
            },
          ],
        },
      },
    },
    styleOverrides: {
      tooltip: ({ theme }) => ({
        fontSize: theme.typography.subtitle2.fontSize,
        maxWidth: '200px',
        lineHeight: theme.typography.subtitle2.lineHeight,
        color: 'var(--mui-palette-Tooltip-text)',
        padding: '8px 12px',
        borderRadius: 'var(--mui-shape-customBorderRadius-sm)',
        backgroundColor: 'var(--mui-palette-Tooltip-bg)',
      }),
    },
  },
};

export { tooltip };
